/**
 * `modules/scrollHint.js`
 * - 大きいテーブルにスクロール可能なヒントを表示
 *
 * 使用方法:
 * - import {scrollHint} from "../modules/scrollHint.js";
 */


import ScrollHint from "scroll-hint";


/**
 * 大きいテーブルを `.table_wrap` でラップする
 */
function wrapTable() {
  const tables = document.querySelectorAll(".contents table");

  tables.forEach((table) => {
    const parentWidth = table.parentElement.offsetWidth;
    const tableWidth = table.offsetWidth;

    if (tableWidth > parentWidth && !table.closest(".table_wrap")) {
      const wrapper = document.createElement("div");
      wrapper.classList.add("table_wrap");
      table.parentElement.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  });
}

/**
 * `.table_wrap` に `scrollHint` を適用する
 */
function initializeScrollHint() {
  const scrollableTables = document.querySelectorAll(".table_wrap");

  scrollableTables.forEach((scrollable) => {
    // 既存のスクロールヒントアイコンがある場合は削除
    const existingHintIcon = scrollable.querySelector(".scroll-hint-icon-wrap");
    if (existingHintIcon) {
      existingHintIcon.remove();
    }
  });

  if (scrollableTables.length > 0) {
    new ScrollHint(scrollableTables, {
      scrollHintIconAppendClass: "scroll-hint-icon-white",
      i18n: {
        scrollable: "スクロールできます",
      },
    });
  }
}

/* =============================================================
 * export function
 * ========================================================== */
export function tableScrollHint() {
  wrapTable();
  initializeScrollHint();
}
